/* DemoPool checkout loader: mirror ball on a canvas, reflections sweeping the room.
   API: dpLoader.show(text), dpLoader.hide(). Auto-shows on cart "Checkout" submit. */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const PAL = [[255, 184, 107], [255, 122, 77], [146, 70, 255], [244, 237, 230], [255, 150, 120]];
  const css = `
.dpl{position:fixed;inset:0;z-index:2147483000;display:grid;place-items:center;overflow:hidden;opacity:0;transition:opacity .3s;
  background:radial-gradient(60% 50% at 50% 42%,rgb(146 70 255/.22),transparent 70%),radial-gradient(40% 30% at 50% 88%,rgb(255 122 77/.18),transparent 70%),rgb(10 8 7/.94);
  -webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);font-family:var(--font,system-ui)}
.dpl[hidden]{display:none} /* 21.10: display:grid beat [hidden], so a hidden loader stayed as an invisible layer over the page and ate every click */
.dpl.is-in{opacity:1}
.dpl__room{position:absolute;left:50%;top:40%;width:220vmax;height:220vmax;margin:-110vmax 0 0 -110vmax;animation:dplspin 14s linear infinite}
.dpl__room i{position:absolute;border-radius:50%;filter:blur(1.5px);opacity:.7;animation:dpltw 2.4s ease-in-out infinite}
.dpl__in{position:relative;display:grid;justify-items:center;gap:22px;text-align:center;padding:24px}
.dpl__cord{width:2px;height:22vh;margin-bottom:-24px;background:linear-gradient(transparent,rgb(244 237 230/.5))}
.dpl canvas{width:200px;height:200px;filter:drop-shadow(0 0 40px rgb(255 150 90/.35)) drop-shadow(0 30px 40px rgb(0 0 0/.6))}
.dpl__floor{width:220px;height:26px;margin-top:-6px;border-radius:50%;background:radial-gradient(closest-side,rgb(255 122 77/.35),transparent);animation:dplpulse 1.6s ease-in-out infinite}
.dpl__t{margin:0;font:600 22px/1.2 var(--font,system-ui);color:#F4EDE6;letter-spacing:-.01em}
.dpl__t span{display:inline-block;width:1.2em;text-align:left}
.dpl__s{margin:-12px 0 0;font:500 15px/1.4 var(--font,system-ui);color:#D3CAC0}
@keyframes dplspin{to{transform:rotate(360deg)}}
@keyframes dpltw{50%{opacity:.15}}
@keyframes dplpulse{50%{transform:scaleX(.8);opacity:.6}}
@media (prefers-reduced-motion:reduce){.dpl__room,.dpl__room i,.dpl__floor{animation:none}}`;
  let el, cv, ctx, raf, t0, dotsT, safety;
  const build = () => {
    const st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
    el = document.createElement('div'); el.className = 'dpl'; el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite'); el.hidden = true;
    let dots = '';
    for (let i = 0; i < 140; i++) {
      const c = PAL[i % PAL.length], s = 4 + Math.random() * 10, a = Math.random() * 6.283, r = 6 + Math.random() * 44;
      dots += `<i style="left:${50 + Math.cos(a) * r}%;top:${50 + Math.sin(a) * r}%;width:${s}px;height:${s}px;background:rgb(${c});box-shadow:0 0 ${s * 2}px rgb(${c});animation-delay:${(-Math.random() * 2.4).toFixed(2)}s"></i>`;
    }
    el.innerHTML = `<div class="dpl__room" aria-hidden="true">${dots}</div><div class="dpl__in"><div class="dpl__cord" aria-hidden="true"></div><canvas width="400" height="400" aria-hidden="true"></canvas><div class="dpl__floor" aria-hidden="true"></div><p class="dpl__t"><b data-t></b><span data-d></span></p><p class="dpl__s">Secure checkout · files land in your inbox</p></div>`;
    document.body.appendChild(el);
    cv = el.querySelector('canvas'); ctx = cv.getContext('2d');
  };
  // tiles: latitude bands, tile count per band follows the circumference
  const N = 15, tiles = [];
  for (let i = 0; i < N; i++) {
    const a0 = -Math.PI / 2 + i * Math.PI / N, a1 = a0 + Math.PI / N, m = Math.max(4, Math.round(2 * N * Math.cos((a0 + a1) / 2)));
    for (let j = 0; j < m; j++) tiles.push({ a0, a1, l0: j * 6.2832 / m, w: 6.2832 / m, c: PAL[(i * 7 + j * 3) % PAL.length], ph: Math.random() * 6.283, sp: .6 + Math.random() * 1.4 });
  }
  const L = (() => { const v = [-.45, .6, .66], n = Math.hypot(...v); return v.map(x => x / n); })();
  const P = (a, l) => [Math.cos(a) * Math.sin(l), Math.sin(a), Math.cos(a) * Math.cos(l)];
  const draw = t => {
    const S = cv.width, R = S * .44, cx = S / 2, cy = S / 2, rot = t * .00045;
    ctx.clearRect(0, 0, S, S);
    const bg = ctx.createRadialGradient(cx - R * .3, cy - R * .35, R * .1, cx, cy, R);
    bg.addColorStop(0, '#3a2c28'); bg.addColorStop(1, '#0d0a09');
    ctx.fillStyle = bg; ctx.beginPath(); ctx.arc(cx, cy, R, 0, 6.2832); ctx.fill();
    const glints = [];
    for (const k of tiles) {
      const l0 = k.l0 + rot, l1 = l0 + k.w, am = (k.a0 + k.a1) / 2, lm = (l0 + l1) / 2, n = P(am, lm);
      if (n[2] <= .02) continue;
      const g = .1, a0 = k.a0 + (k.a1 - k.a0) * g, a1 = k.a1 - (k.a1 - k.a0) * g, b0 = l0 + k.w * g, b1 = l1 - k.w * g;
      const q = [P(a0, b0), P(a0, b1), P(a1, b1), P(a1, b0)];
      const d = Math.max(0, n[0] * L[0] + n[1] * L[1] + n[2] * L[2]);
      const tw = Math.pow(Math.max(0, Math.sin(t * .002 * k.sp + k.ph)), 24);
      const lit = Math.min(1.35, .3 + .85 * d * d + tw * .9) * (.35 + .65 * n[2]);
      const w = Math.min(1, tw * .8 + Math.pow(d, 12));
      const col = k.c.map(v => Math.round(Math.min(255, (v * (1 - w) + 255 * w) * lit)));
      ctx.fillStyle = `rgb(${col})`;
      ctx.beginPath(); q.forEach((p, i) => ctx[i ? 'lineTo' : 'moveTo'](cx + R * p[0], cy - R * p[1])); ctx.closePath(); ctx.fill();
      if (tw > .75 && n[2] > .35) glints.push([cx + R * n[0], cy - R * n[1], tw]);
    }
    const sh = ctx.createRadialGradient(cx - R * .38, cy - R * .42, 0, cx - R * .38, cy - R * .42, R * .9);
    sh.addColorStop(0, 'rgb(255 255 255/.28)'); sh.addColorStop(.35, 'rgb(255 255 255/.05)'); sh.addColorStop(1, 'rgb(0 0 0/0)');
    ctx.fillStyle = sh; ctx.beginPath(); ctx.arc(cx, cy, R, 0, 6.2832); ctx.fill();
    ctx.strokeStyle = 'rgb(255 255 255/.9)'; ctx.lineCap = 'round';
    for (const [x, y, s] of glints) {
      const r = 10 + 16 * s; ctx.lineWidth = 2;
      ctx.beginPath(); ctx.moveTo(x - r, y); ctx.lineTo(x + r, y); ctx.moveTo(x, y - r); ctx.lineTo(x, y + r); ctx.stroke();
      const gl = ctx.createRadialGradient(x, y, 0, x, y, r * .6); gl.addColorStop(0, 'rgb(255 255 255/.9)'); gl.addColorStop(1, 'rgb(255 255 255/0)');
      ctx.fillStyle = gl; ctx.beginPath(); ctx.arc(x, y, r * .6, 0, 6.2832); ctx.fill();
    }
  };
  const loop = now => { draw(now - t0); raf = requestAnimationFrame(loop); };
  const show = (text = 'Spinning up checkout') => {
    if (!el) build();
    el.querySelector('[data-t]').textContent = text;
    el.hidden = false; requestAnimationFrame(() => el.classList.add('is-in'));
    cancelAnimationFrame(raf); t0 = performance.now();
    if (reduce) draw(1200); else raf = requestAnimationFrame(loop);
    const d = el.querySelector('[data-d]'); let k = 0; clearInterval(dotsT);
    d.textContent = '...'; if (!reduce) dotsT = setInterval(() => { d.textContent = '.'.repeat(++k % 4); }, 380);
    clearTimeout(safety); safety = setTimeout(hide, 20000);
  };
  const hide = () => {
    if (!el) return; el.classList.remove('is-in'); cancelAnimationFrame(raf); clearInterval(dotsT); clearTimeout(safety);
    setTimeout(() => { if (!el.classList.contains('is-in')) el.hidden = true; }, 300);
  };
  window.dpLoader = { show, hide };
  addEventListener('pageshow', e => { if (e.persisted) hide(); });
  document.addEventListener('submit', e => {
    const b = e.submitter; if (e.defaultPrevented || !b || b.name !== 'checkout') return;
    show('Spinning up checkout');
  });
  if (/[?&]dploader=1/.test(location.search)) addEventListener('load', () => show());
})();
